import { useSelector } from "react-redux";

import { Row, Spin, Tooltip } from "antd";

const ReportStatisticsItemComponent = ({
	title,
	value,
	unit,
	statistics,
	targetMonth,
}) => {
	const isLoading = useSelector((state) => state.common.loading);

	const tax_text =
		"· 원천세(개인) : -3.3%\n· 부가가치세 포함\n· 카톡푸시 이용 금액 제외";

	return (
		<div className="report-statistics-item-wrap">
			<Row
				align={"middle"}
				justify={"center"}
				style={{ gap: "3px", position: "relative" }}
			>
				{title}
				{title === "정산 금액" && (
					<>
						<Tooltip
							trigger={`click`}
							title={tax_text}
							overlayStyle={{ whiteSpace: "pre-wrap" }}
						>
							<img
								src={`/assets/images/report/notice.png`}
								alt={`세금 안내`}
								style={{
									height: "1.1em",
									width: "auto",
									cursor: "pointer",
								}}
							/>
						</Tooltip>
					</>
				)}
			</Row>
			{isLoading ? (
				<Spin style={{ margin: "auto", width: "100%", paddingTop: "1em" }} />
			) : (
				<>
					{title === "카톡푸시 이용 금액" &&
					!value &&
					statistics?.purchases_complete_num ? (
						<div
							className="report-statistics-value-wrap"
							style={
								title === "정산 금액"
									? {
											color: "#117ffa",
									  }
									: {}
							}
						>
							{unit
								? unit === "%"
									? parseFloat(value).toFixed(2)
									: value.toLocaleString()
								: value.toLocaleString()}
							{unit ? unit : null}
						</div>
					) : (
						<>
							{value && value !== null && (
								<div
									className="report-statistics-value-wrap"
									style={
										title === "정산 금액"
											? {
													color: "#117ffa",
											  }
											: {}
									}
								>
									{unit
										? unit === "%"
											? parseFloat(value).toFixed(2)
											: value.toLocaleString()
										: value.toLocaleString()}
									{unit ? unit : null}
								</div>
							)}
						</>
					)}
				</>
			)}
		</div>
	);
};

export default ReportStatisticsItemComponent;
